/* Page for testing functions, components... */
import React from 'react';
import { Layout } from 'components/organisms';
import { FileSelectModal } from 'containers';

const Dummy = () => (
  <Layout>
    <FileSelectModal isOpen />
  </Layout>
);

export default Dummy;
